<textarea
  matInput
  cdkTextareaAutosize
  #autosize="cdkTextareaAutosize"
  cdkAutosizeMinRows="1"
  [cdkAutosizeMaxRows]="maxrows"
  [(ngModel)]="text"
  [readonly]="readonly"
  class="inline-textarea"
  #inlineTextareaElement
  [maxlength]="maxchars"
  (change)="emitTextChange()"
  (keydown.enter)="onEnter($event)"
  [placeholder]="placeholderText"
  data-test="in-place-textarea"
></textarea>
